import React from "react";
import { useForm } from "react-hook-form";

export default function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
        <div className="row">
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Name<span className="star-requried">*</span></label>
            <input
              type="text"
              className="cs_form_field"
              placeholder="David John"
              {...register("name", { required: "Name is required" })}
            />
             {errors.name && <span className="error-message-text">{errors.name.message}</span>}
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Email<span className="star-requried">*</span></label>
            <input
              type="email"
              className="cs_form_field"
              placeholder="example@gmail.com"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\\s@]+@[^\\s@]+\.[^\\s@]+$/,
                  message: "Invalid email address",
                },
              })}
            />
            {errors.email && <span className="error-message-text">{errors.email.message}</span>}
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Subject<span className="star-requried">*</span></label>
            <input
              type="text"
              className="cs_form_field"
              placeholder="Your subject"
              {...register("subject", { required: "Subject is required" })}
            />
             {errors.subject && <span className="error-message-text">{errors.subject.message}</span>}
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Message<span className="star-requried">*</span></label>
            <textarea
              cols={30}
              rows={10}
              className="cs_form_field"
              placeholder="Write something..."
              defaultValue={""}
              {...register("message", { required: "Message is required" })}
            />
            {errors.message && <span className="error-message-text">{errors.message.message}</span>}
            <div className="cs_height_42 cs_height_xl_25" />
          </div>
          <div className="col-lg-12">
            <div className="cs_height_18" />
            <button className="cs_btn cs_style_1">
              <span type="submit">Submit</span>
              <i>
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
              </i>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
